import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from 'src/app/_services/account.service';

@Component({
  selector: 'app-modal-pasajero-confirmado',
  templateUrl: './modal-pasajero-confirmado.component.html',
  styleUrls: ['./modal-pasajero-confirmado.component.css']
})
export class ModalPasajeroConfirmadoComponent implements OnInit {

  submitted = false;
  errorLogin = false;
  form: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,    
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
  }

  onSubmit() {
    this.submitted = true;
    this.errorLogin = false;

    
  }

  closeModal(){
    //this.router.navigate(['/admin/tours-agencias-reservados']);
    this.activeModal.dismiss('Cross click');
  }

}
